import { UNISWAP_TICK } from '../ui-config/constants';

export const convertPercentToTickDiff = (percent: number) => {
  return Math.round(logBase(UNISWAP_TICK, 1 + (percent / 100)));
}

function logBase(base: number, x: number) {
  return Math.log(x) / Math.log(base);
}
